(() => {
  const template = () => document.querySelector('template[data-vc-global-card]');
  class VelvetProductCard extends HTMLElement {
    connectedCallback() {
      this.compose();
      this.addEventListener('submit', this.addToCart);
    }
    disconnectedCallback() { this.removeEventListener('submit', this.addToCart); }
    compose(force = false) {
      const shared = template();
      const data = this.querySelector('template[data-vc-card-data]');
      const body = this.querySelector('[data-vc-card-body]');
      if (!shared || !data || !body || (!force && body.querySelector('[data-vc-composed]'))) return;
      const fields = new Map([...data.content.querySelectorAll('[data-vc-field]')].map(field => {
        // These fields occur in attributes too. DOM text serialization preserves raw quotes.
        const value = ['title', 'url'].includes(field.dataset.vcField)
          ? field.innerHTML.replaceAll('"', '&quot;').replaceAll("'", '&#39;') : field.innerHTML;
        return [field.dataset.vcField, value];
      }));
      // Replace tokens in the original template only; never reinterpret product content.
      body.innerHTML = shared.innerHTML.replace(/\[\[vc:([a-z_]+)\]\]/g, (_, field) => fields.get(field) || '');
    }
    async addToCart(event) {
      const form = event.target.closest('[data-vc-add-form]');
      if (!form || !this.contains(form) || !window.fetch) return;
      event.preventDefault();
      const button = form.querySelector('button');
      if (button.disabled) return;
      const action = form.closest('.vc-product-action');
      const labels = [...button.querySelectorAll('[data-vc-add-label]')];
      const error = action.querySelector('.vc-add-error');
      const original = labels.map(label => label.textContent);
      const setLabels = text => labels.forEach(label => { label.textContent = text; });
      const endpoint = new URL(form.action);
      endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
      button.disabled = true; button.setAttribute('aria-busy', 'true');
      setLabels(action.dataset.adding); error.hidden = true;
      let added = false;
      try {
        if (window.VelvetCart) {
          const fields = new FormData(form);
          await window.VelvetCart.add([{ id: Number(fields.get('id')), quantity: Number(fields.get('quantity') || 1) }], { opener: button });
          added = true; setLabels(action.dataset.added); this.announce(action.dataset.added);
          return;
        }
        const response = await fetch(endpoint, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : action.dataset.error);
        added = true; setLabels(action.dataset.added);
        this.announce(action.dataset.added);
        // Cart refresh failure must not report the successful add as a failure.
        try {
          const cartURL = new URL(endpoint); cartURL.pathname = cartURL.pathname.replace(/\/cart\/add\.js$/, '/cart.js');
          const cartResponse = await fetch(cartURL, { headers: { Accept: 'application/json' } });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-cart-count]').forEach(count => { count.textContent = String(cart.item_count); });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          }
        } catch { /* Keep the successful add result. */ }
      } catch (failure) {
        error.textContent = failure.message || action.dataset.error; error.hidden = false;
      } finally {
        button.removeAttribute('aria-busy');
        const restore = () => { button.disabled = false; labels.forEach((label, index) => { label.textContent = original[index]; }); };
        if (added) window.setTimeout(restore, 1600); else restore();
      }
    }
    announce(message) {
      let status = this.querySelector('[data-vc-status]');
      if (!status) {
        status = document.createElement('span'); status.className = 'vc-sr-only'; status.dataset.vcStatus = '';
        status.setAttribute('role', 'status'); this.append(status);
      }
      status.textContent = message;
    }
  }
  if (!customElements.get('velvet-product-card')) customElements.define('velvet-product-card', VelvetProductCard);
  if (window.Shopify?.designMode) {
    // When a page already previews real cards, keep the separate sample out of its layout.
    if (document.querySelector('main velvet-product-card')) {
      document.querySelectorAll('[data-vc-editor-preview]').forEach(preview => { preview.hidden = true; });
    }
    document.addEventListener('shopify:section:load', event => {
      const global = event.target.querySelector('[data-vc-global-config]');
      if (global) {
        document.querySelectorAll('velvet-product-card').forEach(card => card.compose(true));
        const preview = global.querySelector('[data-vc-editor-preview]');
        if (preview) preview.hidden = false;
      } else event.target.querySelectorAll('velvet-product-card').forEach(card => card.compose(true));
    });
    document.addEventListener('shopify:section:select', event => {
      const preview = event.target.querySelector('[data-vc-editor-preview]');
      if (preview) preview.hidden = false;
    });
    document.addEventListener('shopify:section:deselect', event => {
      const preview = event.target.querySelector('[data-vc-editor-preview]');
      if (preview) preview.hidden = true;
    });
    document.addEventListener('shopify:block:select', event => {
      const section = document.getElementById('shopify-section-' + event.detail.sectionId);
      const preview = section?.querySelector('[data-vc-editor-preview]');
      if (preview) { preview.hidden = false; preview.scrollIntoView({ block: 'nearest' }); }
    });
  }
})();
